<template>
  <router-link to="/" class="site-logo">
    <span ref="siteLogo">
      <img src="/static/img/logo.png" /> <span>{{ name }} <small v-if="subtitle">{{ subtitle }}</small></span>
    </span>
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      name: 'JEROME DUPUIS'
    };
  },
  props: {
    subtitle: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layouts/common/SiteLogo.vue